export enum ScreenState {
  Content = 0,
  Loading = 1,
  Error = 2
}
